


const generateID = () => {
  const timestamp = (new Date().getTime() / 1000 | 0).toString(16).padStart(8, '0');
  const machineId = Math.floor(Math.random() * 16777216).toString(16).padStart(6, '0');
  const processId = Math.floor(Math.random() * 65536).toString(16).padStart(4, '0');
  const increment = Math.floor(Math.random() * 16777216).toString(16).padStart(6, '0');
  return timestamp + machineId + processId + increment;
};


const updateMiniCart = async () => {
  const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`, { 'Content-Type': 'application/json' });
  const cartContent = await cartResponse.json();
  document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
    bubbles: true,
    detail: {
      cart: cartContent,
    }
  }));
}


var work_slide = $('.work-slide').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  autoplay: false,
});

$(".slider").slick({
  infinite: true,
  arrows: false,
  dots: false,
  autoplay: false,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
});

 //ticking machine
    var percentTime;
    var tick;
    var time = .1;
    var progressBarIndex = 0;

    $('.how_work_inner .progressBarContainer .progressBar').each(function(index) {
        var progress = "<div class='inProgress inProgress" + index + "'></div>";
        $(this).html(progress);
    });

    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        tick = setInterval(interval, 10);
    }

    function interval() {
        if (($('.how_work_inner  .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
            progressBarIndex = $('.slider .slick-track div[aria-hidden="false"]').data("slickIndex");
            startProgressbar();
        } else {
            percentTime += 1 / (time + 4);
            $('.inProgress' + progressBarIndex).css({
                width: percentTime + "%"
            });
            $('.work-slide .slick-dots .slick-active button').css({
                width: percentTime + "%"
            });
            if (percentTime >= 100) {
               $('.work-slide').slick('slickNext');
                progressBarIndex++;
                if (progressBarIndex > 2) {
                    progressBarIndex = 0;
                }
                startProgressbar();
            }
        }
    }

    function resetProgressbar() {
        $('.inProgress').css({
            width: 0 + '%'
        });
        $('.work-slide .slick-dots .slick-active button').css({
                width: 0 + "%"
        });
        clearInterval(tick);
    }
    startProgressbar();
    // End ticking machine


// if($('.work-slide').length > 0){
//   var i = 0.05;
//   var is_change = 0;
//   var inter = setInterval(function(e) {
//       if(i >= 100){
//         if(is_change == 0){
//          setTimeout(function(e) {
//             work_slide.slick('next');
//             is_change = 1;
//           },200) 
//         }
//         if(is_change == 1){
//           setTimeout(function(e) {
//             i = 0.05;
//             is_change = 0;
//           },300)
//         }
//       }else{
//         $('.work-slide .slick-dots .slick-active button').css('width',i+'%');
//       }
//     i++;
//   },15)
  
// }

$('.pets_slider').slick({ 
  slidesToScroll: 1,
  slidesToShow: 5,
  dots: false,
  arrows: false,
  autoplay: true,
  infinite: true,
  speed: 300,
  autoplaySpeed: 50000,
  centerMode: true,
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});

var $pet_slide = $('.pets_slider');
$pet_slide.on('click', '.slick-slide', function(e) {
            e.preventDefault();
            var index = $(this).data("slick-index");
            $pet_slide.slick('slickGoTo', index);
        });
function assignSlideClasses() {
  var $allSlides = $('.pets_slider .pets_items');
  var $activeSlides = $('.pets_slider .pets_items.slick-active');

  $allSlides.removeClass('previous_slide next_slide left_previous next_right current_slide');

  var activeCount = $activeSlides.length;
  if (activeCount === 0) return;

  // Determine the "current" slide
  var $currentSlide = $activeSlides.filter('.slick-current');
  var currentIndex;
  if ($currentSlide.length > 0) {
    currentIndex = $activeSlides.index($currentSlide.first());
  } else {
    currentIndex = Math.floor(activeCount / 2);
    $currentSlide = $activeSlides.eq(currentIndex);
  }

  // Assign classes based on relative positions
  $currentSlide.addClass('current_slide');

  // Assign previous & left_previous
  if (currentIndex > 0) {
    $activeSlides.eq(currentIndex - 1).addClass('previous_slide');
    $activeSlides.slice(0, currentIndex - 1).addClass('left_previous');
  }

  // Assign next & next_right
  if (currentIndex < activeCount - 1) {
    $activeSlides.eq(currentIndex + 1).addClass('next_slide');
    $activeSlides.slice(currentIndex + 2).addClass('next_right');
  }
}
$pet_slide.on('afterChange', function() {
  assignSlideClasses();
});
$pet_slide.on('swipe', function() {
  assignSlideClasses();
});
assignSlideClasses();




  $('.community_sldier').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 5000,
    centerMode: true,
    autoplay: true,
    infinite: true,
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$(window).scroll(function(){
  if ($(window).scrollTop() >= 20) {
    $('.shopify-section--header').addClass('fixed-shadow');
   }
   else {
    $('.shopify-section--header').removeClass('fixed-shadow');
   }
});


function allulheight() {
  var heightarray = new Array();
  $('.comunity_content').removeAttr('style');
  $('.comunity_content').each(function() {
      var height = $(this).height();
      heightarray.push(height);
  });
  var maxheight = Math.max.apply(Math,heightarray);
  $('.comunity_content').height(maxheight);

}
setTimeout(function(e){
allulheight();
},500)

$(window).resize(function(){
	allulheight();
});
